/**
 * Mable Events Worker
 * Handles Mable events and analytics
 */

import { Logger } from '@/shared/logger/logger';

import { AbstractWorker } from '../shared/abstract_worker';
import { MableEventsTaskProcessor } from './task_processor';

/**
 * Concrete worker class for Mable Events
 */
export class MableEventsWorker extends AbstractWorker {
  /**
   * Worker name for logging and identification
   */
  protected readonly workerName = 'Mable Events';

  /**
   * Bundle name for the worker
   */
  protected readonly bundleName = 'mable_events';

  /**
   * Task processor instance
   */
  protected readonly taskProcessor = new MableEventsTaskProcessor();

  /**
   * Constructor
   * Initializes the worker
   */
  constructor() {
    super();
    this.initialize().catch(error => {
      Logger.error('Failed to initialize Mable Events worker:', error);
    });
  }
}

/**
 * Create and expose the worker instance
 */
const workerInstance = new MableEventsWorker();

// Make sure the worker is accessible in the global scope for debugging
// @ts-expect-error - This is intentional
self.mableEventsWorker = workerInstance;
